export default __webpack_public_path__ + "static/media/OverBackgroundOCH.17d68616.png";